module.exports = __webpack_public_path__ + "static/media/2. Alambre11, Óleo, malla Alambre, yeso, gesso y cemento, 120 x 180 cm, 2019 copy.c9f199ca.png";